import axios from 'axios';

export const reverseGeocode = async (lat, lon) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/geo/reverse`, { params: { lat, lon } });
    return data.address;
};

export const lookupPincode = async (pincode) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/geo/pincode/${pincode}`);
    return data;
};

export const getCurrentPosition = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
        reject(new Error('Your browser does not support location access.'));
        return;
    }
    navigator.geolocation.getCurrentPosition(
        (position) => resolve(position.coords),
        (error) => reject(new Error(error.code === 1
            ? 'Location permission was denied. Please allow it in your browser, or fill the address manually.'
            : 'Could not get your location. Please fill the address manually.')),
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 }
    );
});
